/**
 * LISTADO DE ENDPOINTS API DE CONSULTAS https://apiconsultasaddev.azurewebsites.net
 */
const URL_API_CONSULTAS = {
    /**
     * GetActividades_Inforequest ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene información de las actividades.
     */
    GET_ACTIVIDADES_INFO_REQUEST: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Actividades/GetActividades_Inforequest`,

    /**
     * GetActividades_InforequestV2 ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Versión 2 para obtener información de las actividades.
     */
    GET_ACTIVIDADES_INFO_REQUEST_V2: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Actividades/v2/GetActividades_InforequestV2`,

    /**
     * GetAlertaUsuarios_Info ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene información de las alertas de los usuarios.
     */
    GET_ALERTA_USUARIOS_INFO: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Actividades/GetAlertaUsuarios_Info`,

    /**
     * VerificarExistenAlertas ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Verifica si existen alertas para un usuario, con un parámetro de consulta "visto".
     */
    VERIFICAR_EXISTEN_ALERTAS: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Actividades/VerificarExistenAlertas`,

    /**
     * GetAlguaciles ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene la lista de alguaciles.
     */
    GET_ALGUACILES: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Alguaciles/GetAlguaciles`,

    /**
     * cbAsuntosPorIdTipoProcedimiento ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene asuntos por el ID del tipo de procedimiento.
     */
    CB_ASUNTOS_POR_ID_TIPO_PROCEDIMIENTO: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Asuntos/cbAsuntosPorIdTipoProcedimiento`,

    /**
     * cbAsuntosPorIdAsunto ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene asuntos por el ID del asunto.
     */
    CB_ASUNTOS_POR_ID_ASUNTO: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Asuntos/cbAsuntosPorIdAsunto`,

    /**
     * cbAsuntos ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Obtiene una lista de todos los asuntos.
     */
    CB_ASUNTOS: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Asuntos/cbAsuntos`,

    /**
     * ObtenerNaturalezaAsuntoPorIdCaso ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene la naturaleza de un asunto por el ID del caso.
     */
    OBTENER_NATURALEZA_ASUNTO_POR_ID_CASO: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Asuntos/ObtenerNaturalezaAsuntoPorIdCaso`,

    /**
     * cbAsuntosPorIdTipoProcedimientoProcedencia ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene asuntos por el ID del tipo de procedimiento y procedencia.
     */
    CB_ASUNTOS_POR_ID_TIPO_PROCEDIMIENTO_PROCEDENCIA: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Asuntos/cbAsuntosPorIdTipoProcedimientoProcedencia`,

    /**
     * cbAsuntosPorIdTipoProcedimientoV2 ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Versión 2 que obtiene asuntos por ID de materia y tipo de procedimiento.
     */
    CB_ASUNTOS_POR_ID_TIPO_PROCEDIMIENTO_V2: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Asuntos/v2/cbAsuntosPorIdTipoProcedimiento`,

    /**
     * GetTiposDocumentosPorIdAsunto ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene los tipos de documentos requeridos por el ID del asunto.
     */
    GET_TIPOS_DOCUMENTOS_POR_ID_ASUNTO: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/AsuntoTipoDocumentoRequeridos/GetTiposDocumentosPorIdAsunto`,

    /**
     * GetFechaAudienciasPorUsuario ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene las fechas de audiencias por el ID del usuario.
     */
    GET_FECHA_AUDIENCIAS_POR_USUARIO: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Audiencias/GetFechaAudienciasPorUsuario`,

    /**
     * GetFechasAudienciasPorEntidad ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene las fechas de audiencias por la entidad.
     */
    GET_FECHAS_AUDIENCIAS_POR_ENTIDAD: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Audiencias/GetFechasAudienciasPorEntidad`,

    /**
     * GetAudienciasPorFechaAudienciaIdUsuario ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene las audiencias por una fecha y un ID de usuario.
     */
    GET_AUDIENCIAS_POR_FECHA_AUDIENCIA_ID_USUARIO: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Audiencias/GetAudienciasPorFechaAudienciaIdUsuario`,

    /**
     * GetAudienciasPorFechaAudienciaIdRelUsuarioEntidades ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene las audiencias por una fecha y el ID de la relación usuario-entidad.
     */
    GET_AUDIENCIAS_POR_FECHA_AUDIENCIA_ID_REL_USUARIO_ENTIDADES: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Audiencias/GetAudienciasPorFechaAudienciaIdRelUsuarioEntidades`,

    /**
     * GetFechasAudienciasPorRolAbogadoParalegal ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene las fechas de audiencias para roles de abogado o paralegal.
     */
    GET_FECHAS_AUDIENCIAS_POR_ROL_ABOGADO_PARALEGAL: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Audiencias/GetFechasAudienciasPorRolAbogadoParalegal`,

    /**
     * GetAudienciasPorIdAudiencia ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene la información de una audiencia específica por su ID.
     */
    GET_AUDIENCIAS_POR_ID_AUDIENCIA: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Audiencias/GetAudienciasPorIdAudiencia`,

    /**
     * GetConfiguracionSalaAudiencias ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene la configuración de una sala de audiencias.
     */
    GET_CONFIGURACION_SALA_AUDIENCIAS: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Audiencias/GetConfiguracionSalaAudiencias`,

    /**
     * VerificarDisponibilidadTramiteFijarAudiencia ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Verifica la disponibilidad de un trámite para fijar una audiencia.
     */
    VERIFICAR_DISPONIBILIDAD_TRAMITE_FIJAR_AUDIENCIA: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Audiencias/VerificarDisponibilidadTramiteFijarAudiencia`,

    /**
     * GetFechasDisponiblesAudienciasPorMesSala ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene las fechas disponibles para audiencias por mes y sala.
     */
    GET_FECHAS_DISPONIBLES_AUDIENCIAS_POR_MES_SALA: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Audiencias/GetFechasDisponiblesAudienciasPorMesSala`,

    /**
     * cbModalidadesdAudiencias ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Obtiene todas las modalidades de audiencias disponibles.
     */
    CB_MODALIDADES_DE_AUDIENCIAS: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Audiencias/cbModalidadesdAudiencias`,

    /**
     * cbTipoConvovatoria ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Obtiene todos los tipos de convocatoria.
     */
    CB_TIPO_CONVOCATORIA: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Audiencias/cbTipoConvovatoria`,

    /**
     * cbTipoAudiencia ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Obtiene todos los tipos de audiencia.
     */
    CB_TIPO_AUDIENCIA: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Audiencias/cbTipoAudiencia`,

    /**
     * cbTipoAudienciaIdMateria ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene los tipos de audiencia por el ID de la materia.
     */
    CB_TIPO_AUDIENCIA_ID_MATERIA: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Audiencias/cbTipoAudienciaIdMateria`,

    /**
     * cbModalidadesdAudienciasPorIdSala ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene las modalidades de audiencias por el ID de la sala.
     */
    CB_MODALIDADES_DE_AUDIENCIAS_POR_ID_SALA: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Audiencias/cbModalidadesdAudienciasPorIdSala`,

    /**
     * usuarios/audiencias ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Versión 2 que obtiene las audiencias de un usuario por su ID en la URL.
     */
    USUARIOS_AUDIENCIAS_V2: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Audiencias/v2/usuarios`,

    /**
     * GetFechaAudienciasPorUsuarioV2 ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Versión 2 que obtiene las fechas de audiencias por usuario.
     */
    GET_FECHA_AUDIENCIAS_POR_USUARIO_V2: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Audiencias/v2/GetFechaAudienciasPorUsuario`,
    /**
     * GetFechaAudienciasPorRolAbogadoParalegal ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Versión 2 que obtiene las fechas de audiencias por usuario.
     */
    GET_FECHA_AUDIENCIAS_POR_ABOGADO_PARA_LEGAL_V2: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Audiencias/v2/GetFechaAudienciasPorRolAbogadoParalegal`,
    /**
     * GetFechaAudienciasPorIdRelUsuarioEntidades ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Versión 2 que obtiene las fechas de audiencias por usuario.
     */
    GET_FECHA_AUDIENCIAS_POR_USUARIO_ENTIDADES_V2: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Audiencias/v2/GetFechaAudienciasPorIdRelUsuarioEntidades`,

    /**
     * GetCasosporUsuario ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene los casos de un usuario.
     */
    GET_CASOS_POR_USUARIO: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/casos/GetCasosporUsuario`,

    /**
     * GetCasosporIdRelUsuarioEntidades ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene los casos por la relación entre el usuario y las entidades.
     */
    GET_CASOS_POR_ID_REL_USUARIO_ENTIDADES: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/casos/GetCasosporIdRelUsuarioEntidades`,

    /**
     * GetCasosporRolAbogadoParalegal ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene los casos relacionados con un rol de abogado o paralegal.
     */
    GET_CASOS_POR_ROL_ABOGADO_PARALEGAL: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/casos/GetCasosporRolAbogadoParalegal`,

    /**
     * GetCasosporUsuarioV2 ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Versión 2 que obtiene los casos de un usuario, con parámetros de consulta.
     */
    GET_CASOS_POR_USUARIO_V2: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/casos/v2/GetCasosporUsuario`,

    /**
     * GetCasosporIdRelUsuarioEntidadesV2 ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Versión 2 que obtiene los casos por la relación usuario-entidad.
     */
    GET_CASOS_POR_ID_REL_USUARIO_ENTIDADES_V2: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/casos/v2/GetCasosporIdRelUsuarioEntidades`,

    /**
     * GetCasosporRolAbogadoParalegalV2 ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Versión 2 que obtiene los casos para roles de abogado o paralegal.
     */
    GET_CASOS_POR_ROL_ABOGADO_PARALEGAL_V2: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/casos/v2/GetCasosporRolAbogadoParalegal`,
                                                                                                   

    /**
     * ObtenerIdCasoPorNuc ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene el ID del caso a partir del NUC (Número Único de Caso).
     */
    OBTENER_ID_CASO_POR_NUC: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/casos/ObtenerIdCasoPorNuc`,
    /**
     * GetCasosStatsUsuario ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Obtiene Estadísticas de casos POR idUsuario
     */
    GET_CASOS_STATS_USUARIO: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/casos/GetCasosStatsUsuario`,
    /**
     * GetCasosStatsAbogadoParalegal ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Obtiene Estadísticas de casos POR IdRelUsuarioEntidades
     */
    GET_CASOS_STATS_ABOGADO_PARA_LEGAL: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/casos/GetCasosStatsAbogadoParalegal`,
    /**
     * GetCasosStatsEntidad ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Obtiene Estadísticas de casos POR IdRelUsuarioEntidades
     */
    GET_CASOS_STATS_USUARIO_ENTIDADES: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/casos/GetCasosStatsEntidad`,
    /**
     * GetDocumentosPorIdUsuario ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Obtiene Estadísticas de Documentos POR idUsuario
     */
    GET_DOCUMENTOS_STATS_USUARIO: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Documentos/v2/GetDocumentosPorIdUsuario`,
    /**
     * GetDocumentosPorRolAbogadoParalegal ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Obtiene Estadísticas de Documentos POR idUsuario - RolAbogadoParalegal
     */
    GET_DOCUMENTOS_STATS_ROL_ABOGADO_PARA_LEGAL: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Documentos/v2/GetDocumentosPorRolAbogadoParalegal`,
    /**
     * GetDocumentosPorIdRelUsuarioEntidades ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Obtiene Estadísticas de Documentos POR IdRelUsuarioEntidades
     */
    GET_DOCUMENTOS_STATS_USUARIO_ENTIDADES: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Documentos/v2/GetDocumentosPorIdRelUsuarioEntidades`,
    /**
     * GetInvolucradosPorIdTramite ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene Lista de Partes POR IdTramite
     */
    GET_INVOLUCRADOS_POR_ID_TRAMITE: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Involucrados/GetInvolucradosPorIdTramite`,
    /**
     * GetInvolucradosPorIdTramite V2 ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Obtiene  Lista de Partes POR IdTramite V2
     */
    GET_INVOLUCRADOS_POR_ID_TRAMITE_V2: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Involucrados/v2/GetInvolucradosPorIdTramite`,
    /**
     * ObtenerInvolucradosPorIdTramite V2 ENDPOINT de la API de Consultas (PAGINADO)
     * Método: GET
     * Descripción: Obtiene Lista de Partes POR IdTramite con paginación
     * @param idTramite - ID del trámite
     * @param pageNumber - Número de página (default: 1)
     * @param pageSize - Tamaño de página (default: 10)
     * @example /api/Involucrados/v2/ObtenerInvolucradosPorIdTramite?idTramite=123&pageNumber=1&pageSize=10
     */
    GET_INVOLUCRADOS_PAGINADO: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Involucrados/v2/ObtenerInvolucradosPorIdTramite`,
    /**
     * GetResumenPorIdRecepcion ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene el resumen del deposito POR IdRecepcion
     */
    GET_RESUMEN_POR_ID_RECEPCION: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Recepcion/GetResumenPorIdRecepcion`,
    /**
     * GetResumenPorIdRecepcion V2 ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Obtiene el resumen del deposito POR IdRecepcion V2
     */
    GET_RESUMEN_POR_ID_RECEPCION_V2: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Recepcion/v2/GetResumenPorIdRecepcion`,
    /**
     * GetInmueblesPorIdInmueble ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene el inmueble POR IdInmueble
     */
    GET_INMUEBLE_POR_ID_INMUEBLE: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Recepcion/GetInmueblesPorIdInmueble`,
    /**
     * cbTribunalesImplementadosPorIdMateria ENDPOINT del API CONSULTA GESTION CASOS
    */
    GET_TRIBUNALES: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Tribunales/cbTribunalesImplementadosPorIdMateria`,
    /**
     * validarImplementacionTribunal ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Valida si el implementacion del tribunal para saber si puede fijar audiencia por idTribunal y idMateria
     */
    VALIDAR_IMPLEMENTACION_TRIBUNAL: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Tribunales/validarImplementacionTribunal`,
    /**
     * cbAsuntosPorIdAsunto ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Valida si el asunto puede fijar audiencia por idAsunto
     */
    VALIDAR_ASUNTO_FIJA_AUDIENCIA: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Asuntos/cbAsuntosPorIdAsunto`,
    /**
     * validarTribunalSortea ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Valida si tribunal sortea
     */
    VALIDAR_TRIBUNAL_SORTEA: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Tribunales/validarTribunalSortea`,
    /**
     * GetMiembrosEntidadPorIdEntidad ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Obtiene los miembros de una entidad por IdEntidad.
     * @example /api/Contactos/v2/ObtenerMiembrosEntidadPorIdEntidad?idEntidad=123
     */
    GET_MEMBERS_OF_ENTITY: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Contactos/v2/ObtenerMiembrosEntidadPorIdEntidad`,
    /**
     * GetUsuarioPorCedula ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Obtiene un usuario por su cédula.
     * @example /api/Contactos/v2/ObtenerUsuarioPorCedula?cedula=12345678
     */
    GET_USER_BY_CEDULA: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Contactos/v2/ObtenerUsuarioPorCedula`,

    // ADD_MEMBER_TO_ENTITY: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Equipo/AddMemberToEntity`,
    // REMOVE_MEMBER_FROM_ENTITY: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Equipo/RemoveMemberFromEntity`
    /**
     * ObtenerDocumentosApelables ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: 
     */
    OBTENER_DOCUMENTOS_APELABLES: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Documentos/ObtenerDocumentosApelables`,
    /**
     * cbSalasImplementadasPorIdTribunalIdMateria ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Listado de salas Por IdTribunal e IdMateria
     */
    GET_SALAS: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Salas/cbSalasImplementadasPorIdTribunalIdMateria`,
    /**
     * GetTramitePorId ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: DETALLES DE UN TRAMITE
     */
    GET_TRAMITE_POR_ID: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Tramites/GetTramitePorId`,
    /**
     * GetTramitePorIdV2 ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: DETALLES DE UN TRAMITE
     */
    GET_TRAMITE_POR_ID_V2: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Tramites/v2/GetTramitePorId`,
    /**
     * GetActividades_InforequestV2 ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: 
     */
    GET_ACTIVIDADES_V2: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Actividades/v2/GetActividades_InforequestV2`,

    /**
     * GET_FILES_USER ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Obtiene los archivos asociados a los casos de un usuario.
     * @example /api/Documentos/v2/ObtenerDocumentosCasosUsuarioEntidad?TipoConsulta=abogado&Id=15&PageNumber=6&PageSize=10' 
     */
    GET_FILES_USER: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Documentos/v2/ObtenerDocumentosCasosUsuarioEntidad`,
    /**
     * GET_TOTALS_FILES_BY_USERS_OR_ENTITY ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Obtiene el total de archivos asociados a los casos de un usuario o entidad.
     * @example /api/Documentos/v2/ObtenerTotalesArchivosCasosUsuarioEntidad?tipoConsulta=1&id=15' 
     */
    GET_TOTALS_FILES_BY_USERS_OR_ENTITY: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Documentos/v2/ObtenerTotalesArchivosCasosUsuarioEntidad`,
    /**
     * ObtenerInmueblesPorIdTramite ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Obtiene el listado de inmuebles POR Idtramite
     */
    OBTENER_INMUEBLES_POR_IDTRAMITE: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Recepcion/v2/ObtenerInmueblesPorIdTramite`,
    /**
     * ObtenerInmueblesPorIdRecepcion ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Obtiene el listado de inmuebles por IdRecepcion
     */
    GET_INMUEBLE_POR_ID_RECEPCION_V2: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Recepcion/v2/GetInmueblePorIdRecepcion`,
    /**
     * ObtenerRepresentantesPorIdTramite V2 ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Obtiene Lista de Representantes POR IdTramite V2
     */
    GET_REPRESENTANTES_POR_ID_TRAMITE_V2: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Involucrados/v2/ObtenerRepresentantesPorIdTramite`,
    /**
     * cbLey ENDPOINT de la API de Consultas
     * Método: GET
     * Descripción: Obtiene Lista de leyes para pago de tasas
     */
    GET_LEY: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Documentos/cbLey`,
    /**
     * cbSoportesLegalPorIdLey ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene Lista de seoporte legal por IdLey
     */
    GET_SOPORTE_LEGAL_POR_ID_LEY: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Documentos/cbSoportesLegalPorIdLey`,
    /**
     * cbTipoTasa ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene Lista de tipo tasa por id soporte legal
     */
    GET_TIPO_TASA_POR_ID_SOPORTE_LEGAL: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Documentos/cbTipoTasa`,
    /**
     * cbTasasPorIdSoporteLegal ENDPOINT de la API de Consultas
     * Método: POST
     * Descripción: Obtiene Lista de tasa por id soporte legal
     */
    GET_TASA_POR_ID_SOPORTE_LEGAL: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Documentos/cbTasasPorIdSoporteLegal`,
};

export default URL_API_CONSULTAS;